import { render, staticRenderFns } from "./EditRecipes.vue?vue&type=template&id=7311f8a7&scoped=true"
import script from "./EditRecipes.vue?vue&type=script&lang=js"
export * from "./EditRecipes.vue?vue&type=script&lang=js"
import style0 from "./EditRecipes.vue?vue&type=style&index=0&id=7311f8a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7311f8a7",
  null
  
)

export default component.exports